export enum BuilderAnalysisType {
  CHARGED_WITH = -1,
  WOBBLER_FILED_AT_FELONY_LEVEL = -2,
  SPECIAL_ALLEGATION_ALLEGED = -3,
  CONVICTED_ANY_CHARGE = -4,
  CONVICTED_OF = -5,
  SPECIAL_ALLEGATION_FOUND_TRUE = -6,
  WOBBLER_CONVICTED_AT_FELONY_LEVEL = -7,
  SENTENCED_TO_PRISON = -8,
  SENTENCE_ABOVE_THRESHOLD = -9,
  SENTENCED_TO_LIFE_WITHOUT_PAROLE = -10,
  SENTENCED_TO_DEATH = -11,
}
